// These constants are injected via webpack environment variables.
// You can add more variables in webpack.common.js or in profile specific webpack.<dev|prod>.js files.
// If you change the values in the webpack config files, you need to re run webpack to update the application

import { environment } from '../environments/environment';
import packageJson from '../../../../package.json';

export const VERSION = `'${packageJson?.version}'`;
export const DEBUG_INFO_ENABLED = !environment.production;
export const BUILD_TIMESTAMP = `'${new Date().getTime()}'`;
export const DEFAULT_COMPANY: 'pel' | 'pec' = 'pec';
